import { Job } from "@/types";
import { IDataProvider } from "@/store";

export interface IJobState {
  job: Job | null;
  jobs: Job[] | null;
  dataProvider: IDataProvider<Job>;
}

export const state: IJobState = {
  job: null,
  jobs: null,
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
};
